import { render } from "./CurrentUserCard.vue?vue&type=template&id=12baa3f1&scoped=true&ts=true"
import script from "./CurrentUserCard.vue?vue&type=script&lang=ts"
export * from "./CurrentUserCard.vue?vue&type=script&lang=ts"

import "./CurrentUserCard.vue?vue&type=style&index=0&id=12baa3f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12baa3f1"]])

export default __exports__